import React, { useState } from 'react';

import { setSystemUserPreferences } from '@services/commonService';

import { VIEW_TYPE_OBJ } from '@utils/MaterialsUtil';
import { getUserPreference, isRequestFromCosting } from '@utils/Util';

import { LIST_VIEW_TYPE } from '@/constants/constant';

import CommonImage from '@/components/CommonImage';

const ListViewType = ({ type, onSelectType, openPresentationView }) => {
	const [selectedViewType, setSelectedViewType] = useState(getUserPreference());

	const onSetViewSetting = async (selected) => {
		let body = { ...selectedViewType };
		let viewTypeKey = VIEW_TYPE_OBJ[type].name;
		setSelectedViewType({
			...selectedViewType,
			[viewTypeKey]: selected
		});
		body = {
			...body,
			[viewTypeKey]: selected
		};
		onSelectType(selected);
		await setSystemUserPreferences(body);
	};

	const getViewType = () => {
		let viewTypeKey = VIEW_TYPE_OBJ[type].name;
		return selectedViewType[viewTypeKey];
	};

	const renderCollectionDropdown = (value) => {
		const imageMapping = {
			[LIST_VIEW_TYPE.IMAGE_VIEW]: {
				src: `/icons/image-view.svg`,
				alt: 'image'
			},
			[LIST_VIEW_TYPE.NARROW_VIEW]: {
				src: `/icons/narrow-view.svg`,
				alt: 'narrow'
			},
			[LIST_VIEW_TYPE.LIST_VIEW]: {
				src: `/icons/list-view.svg`,
				alt: 'list-view'
			}
		};
		const { src, alt } = imageMapping[value] || {
			src: `/icons/large-view.svg`,
			alt: 'large'
		};
		return <CommonImage src={src} alt={alt} />;
	};

	const renderScanViewType = (value) => {
		const imageMapping = {
			[LIST_VIEW_TYPE.LARGE_VIEW]: {
				src: `/icons/large-view.svg`,
				alt: 'large'
			},
			[LIST_VIEW_TYPE.NARROW_VIEW]: {
				src: `/icons/narrow-view.svg`,
				alt: 'narrow'
			},
			[LIST_VIEW_TYPE.LIST_VIEW]: {
				src: `/icons/list-view.svg`,
				alt: 'list-view'
			}
		};
		const { src, alt } = imageMapping[value] || {
			src: `/icons/large-view.svg`,
			alt: 'large'
		};
		return <CommonImage src={src} alt={alt} />;
	};

	const renderSelectedViewType = (value) => {
		if (type === VIEW_TYPE_OBJ.MATERIAL_LIST.type) {
			return value === LIST_VIEW_TYPE.IMAGE_VIEW ? (
				<CommonImage src={`/icons/image-view.svg`} alt="image" />
			) : value === LIST_VIEW_TYPE.NARROW_VIEW ? (
				<CommonImage src={`/icons/narrow-view.svg`} alt="narrow" />
			) : (
				<CommonImage src={`/icons/list-view.svg`} alt="narrow" />
			);
		} else if (type === VIEW_TYPE_OBJ.SAMPLE_DETAILS.type) {
			return value === LIST_VIEW_TYPE.IMAGE_VIEW ? (
				<CommonImage src={`/icons/image-view.svg`} alt="image" />
			) : (
				<CommonImage src={`/icons/list-view.svg`} alt="narrow" />
			);
		} else if (type === VIEW_TYPE_OBJ.BLOCK_LIBRARY_LIST.type) {
			return value === LIST_VIEW_TYPE.CARD_VIEW ? (
				<CommonImage src={`/icons/narrow-view.svg`} alt="image" />
			) : (
				<CommonImage src={`/icons/collection-view-type.svg`} alt="narrow" />
			);
		} else if (type === VIEW_TYPE_OBJ.SCAN_VIEW_TYPE.type) {
			return renderScanViewType(value);
		} else {
			return renderCollectionDropdown(value);
		}
	};

	const renderListOfViewTypes = () => {
		if (type === VIEW_TYPE_OBJ['MATERIAL_LIST'].type || type === VIEW_TYPE_OBJ['SAMPLE_DETAILS'].type) {
			return (
				<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
					{getViewType() !== LIST_VIEW_TYPE.LIST_VIEW && (
						<li onClick={() => onSetViewSetting(LIST_VIEW_TYPE.LIST_VIEW)}>
							<CommonImage src={`/icons/list-view.svg`} alt="list" />
							List View
						</li>
					)}
					{type === VIEW_TYPE_OBJ['MATERIAL_LIST'].type &&
						getViewType() !== LIST_VIEW_TYPE.NARROW_VIEW && (
							<li onClick={() => onSetViewSetting(LIST_VIEW_TYPE.NARROW_VIEW)}>
								<CommonImage src={`/icons/narrow-view.svg`} alt="narrow" />
								Narrow
							</li>
						)}
					{getViewType() !== LIST_VIEW_TYPE.IMAGE_VIEW && (
						<li onClick={() => onSetViewSetting(LIST_VIEW_TYPE.IMAGE_VIEW)}>
							<CommonImage src={`/icons/image-view.svg`} alt="image" />
							Image
						</li>
					)}
				</ul>
			);
		} else if (type === VIEW_TYPE_OBJ['BLOCK_LIBRARY_LIST'].type) {
			return (
				<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
					{getViewType() !== LIST_VIEW_TYPE.CARD_VIEW && (
						<li onClick={() => onSetViewSetting(LIST_VIEW_TYPE.CARD_VIEW)}>
							<CommonImage src={`/icons/narrow-view.svg`} alt="list" />
							Card
						</li>
					)}
					{getViewType() !== LIST_VIEW_TYPE.COLLECTION_VIEW && (
						<li onClick={() => onSetViewSetting(LIST_VIEW_TYPE.COLLECTION_VIEW)}>
							<CommonImage src={`/icons/collection-view-type.svg`} alt="image" />
							Collection
						</li>
					)}
				</ul>
			);
		} else if (type === VIEW_TYPE_OBJ['POM_TAG_LIST'].type || type === VIEW_TYPE_OBJ['POM_LIST'].type) {
			return (
				<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
					{getViewType() !== LIST_VIEW_TYPE.LIST_VIEW && (
						<li onClick={() => onSetViewSetting(LIST_VIEW_TYPE.LIST_VIEW)}>
							<CommonImage src={`/icons/list-view.svg`} alt="list" />
							List View
						</li>
					)}

					{getViewType() !== LIST_VIEW_TYPE.NARROW_VIEW && (
						<li onClick={() => onSetViewSetting(LIST_VIEW_TYPE.NARROW_VIEW)}>
							<CommonImage src={`/icons/narrow-view.svg`} alt="narrow" />
							Narrow
						</li>
					)}
				</ul>
			);
		} else if (type === VIEW_TYPE_OBJ.SCAN_VIEW_TYPE.type) {
			return (
				<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
					{getViewType() !== LIST_VIEW_TYPE.LARGE_VIEW && (
						<li onClick={() => onSetViewSetting(LIST_VIEW_TYPE.LARGE_VIEW)}>
							<CommonImage src={`/icons/large-view.svg`} alt="large" />
							Large
						</li>
					)}
					{getViewType() !== LIST_VIEW_TYPE.NARROW_VIEW && (
						<li onClick={() => onSetViewSetting(LIST_VIEW_TYPE.NARROW_VIEW)}>
							<CommonImage src={`/icons/narrow-view.svg`} alt="narrow" />
							Narrow
						</li>
					)}
					{getViewType() !== LIST_VIEW_TYPE.LIST_VIEW && (
						<li onClick={() => onSetViewSetting(LIST_VIEW_TYPE.LIST_VIEW)}>
							<CommonImage src={`/icons/list-view.svg`} alt="list" />
							List
						</li>
					)}
				</ul>
			);
		} else {
			return (
				<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
					{getViewType() !== LIST_VIEW_TYPE.LARGE_VIEW && (
						<li onClick={() => onSetViewSetting(LIST_VIEW_TYPE.LARGE_VIEW)}>
							<CommonImage src={`/icons/large-view.svg`} alt="large" />
							Large
						</li>
					)}
					{getViewType() !== LIST_VIEW_TYPE.NARROW_VIEW && (
						<li onClick={() => onSetViewSetting(LIST_VIEW_TYPE.NARROW_VIEW)}>
							<CommonImage src={`/icons/narrow-view.svg`} alt="narrow" />
							Narrow
						</li>
					)}
					{getViewType() !== LIST_VIEW_TYPE.IMAGE_VIEW && (
						<li onClick={() => onSetViewSetting(LIST_VIEW_TYPE.IMAGE_VIEW)}>
							<CommonImage src={`/icons/image-view.svg`} alt="image" />
							Image
						</li>
					)}
					{type === VIEW_TYPE_OBJ['COLLECTION_DETAILS'].type &&
						getViewType() !== LIST_VIEW_TYPE.LIST_VIEW && (
							<li onClick={() => onSetViewSetting(LIST_VIEW_TYPE.LIST_VIEW)}>
								<CommonImage src={`/icons/list-view.svg`} alt="list" />
								List
							</li>
						)}
					{type === VIEW_TYPE_OBJ['COLLECTION_DETAILS'].type && !isRequestFromCosting() && (
						<li
							onClick={(e) => {
								e.stopPropagation();
								openPresentationView();
							}}
							data-toggle="modal"
							data-target="#presentationPlay"
							className="text-nowrap"
						>
							<CommonImage className="cursor-pointer" src={`/icons/play-icon.svg`} alt="play" />
							Play presentation
						</li>
					)}
				</ul>
			);
		}
	};

	return (
		<div className="sort-button design-view-sort mt-1">
			<div className="dropdown">
				<button
					className="btn btn-default dropdown-toggle gray_dark_02 regular-14 p-0 pr-2 mr-0"
					type="button"
					data-toggle="dropdown"
				>
					{renderSelectedViewType(getViewType())}
				</button>
				{renderListOfViewTypes()}
			</div>
		</div>
	);
};

export default ListViewType;
